interface ArrayFieldName {
    arrayName: string;
    childArray?: ArrayFieldName;
}

export class MetadataIndex {

    private rawToTranslated: Map<any, any>;
    private translatedToRaw: Map<any, any>;

    public getTranslatedByRaw = (rawMetadata) => {
        return this.rawToTranslated.get(rawMetadata);
    }

    public getRawByTranslated = (translatedMetadata) => {
        return this.translatedToRaw.get(translatedMetadata);
    }

    public updateRawMetadataIndex(oldSettings: any, newSettings: any): any {
    }

    public indexMetadata = (metadataRaw, metadataTranslated) => {
        this.rawToTranslated = new Map();
        this.translatedToRaw = new Map();

        this.rawToTranslated.set(metadataRaw, metadataTranslated);
        this.translatedToRaw.set(metadataTranslated, metadataRaw);

        this.indexArray(metadataRaw.tabs, metadataTranslated.tabs, { arrayName: "regions", childArray: { arrayName: "fields" } });
    }

    private indexArray = (metadataArrayRaw, metadataArrayTranslated, arrayFieldNames: ArrayFieldName) => {
        for (var i = 0; i < metadataArrayRaw.length; i++) {
            metadataArrayRaw[i].guid = kendo.guid();
            metadataArrayTranslated[i].guid = metadataArrayRaw[i].guid;
            this.rawToTranslated.set(metadataArrayRaw[i], metadataArrayTranslated[i]);
            this.translatedToRaw.set(metadataArrayTranslated[i], metadataArrayRaw[i]);

            if (arrayFieldNames && metadataArrayRaw[i][arrayFieldNames.arrayName]) {
                this.indexArray(metadataArrayRaw[i][arrayFieldNames.arrayName], metadataArrayTranslated[i][arrayFieldNames.arrayName], arrayFieldNames.childArray);
            }
        }
    }

    public addNewMetadata = (newMetadata) => {
        newMetadata.guid = kendo.guid();
        const rawMetadata = $.extend(true, {}, newMetadata);

        this.rawToTranslated.set(rawMetadata, newMetadata);
        this.translatedToRaw.set(newMetadata, rawMetadata);
    }
}